export const UPDATE_MODEL_EVENT = 'update:modelValue'
